import { Field, Stack } from '@components/ui';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { hostedFieldSx } from './hostedFields';

interface CardFieldsProps {
  sx?: SxProps<Theme>;
}

export const CardFields = ({ sx }: CardFieldsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack sx={[{ gap: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Field label={t('payments.cardNumber')}>
        <Box id="bt-card-number" sx={hostedFieldSx} />
      </Field>
      <Field label={t('payments.nameOnCard')}>
        <Box id="bt-name" sx={hostedFieldSx} />
      </Field>
      <Stack direction="row" gap="sm">
        <Field label={t('payments.expiry')} sx={{ flex: 1 }}>
          <Box id="bt-expiry" sx={hostedFieldSx} />
        </Field>
        <Field label={t('payments.cvv')} sx={{ flex: 1 }}>
          <Box id="bt-cvv" sx={hostedFieldSx} />
        </Field>
      </Stack>
    </Stack>
  );
};
